// src/encounter/lib/visit-questionnaire.ts
//
// PROD-2947 (integration of the 6 Oct live-fix lanes). The template as the note draws it for THIS patient, in the
// one order both lanes need, shared by the page and the live-dev story so a story can never scope differently from
// the page (the 6 Oct contract: verdicts come from the served template, L0):
//   1. the `-male` / `-female` group convention (PROD-1497);
//   2. lane C (PROD-3042): the template's own sex / age conditions with the patient as launch context — hidden `ctx-`
//      items and the answer-based enableWhen on them, the SDC enableWhenExpression / answerOptionsToggleExpression.
//      FRAME V2 ONLY (integration, Codex P1 x2): lane C ran it in both frames, but with the switch OFF it could hide an
//      item and, through the page's save (`withoutPatientExcluded`), drop an answer the legacy gender filter kept — a
//      change to OFF (G6). OFF gets the gender filter only and no exclusions, exactly as before lane C. (Live
//      templates carry no `ctx-` item: the 6 Oct 19:45 correction puts chart population on `item.code`.)
//   3. lane A (PROD-3040), frame v2 only and AFTER step 2, because step 2 reads the `ctx-` items' calculatedExpression:
//      a launch-context calculatedExpression + readOnly item becomes an ordinary item carrying its population
//      expression (filled when the record holds the value, asked when not).
import type { Questionnaire } from '@scripsteam/scrips-signal-ds';
import type { FhirQuestionnaire } from '@/types/template-studio-api';
import { filterQuestionnaireByGender } from './questionnaire-groups';
import { NO_EXCLUSIONS, scopeToPatient, toLaunchPatient, type PatientExclusions } from './patient-context';
import { normalizePopulationItems } from './chart-population';

export function visitQuestionnaire(
  template: Questionnaire,
  fhir: FhirQuestionnaire | null | undefined,
  patient: { sex: string | null | undefined; birthDateIso: string | null | undefined },
  frameV2On: boolean,
  today?: Date,
): { questionnaire: Questionnaire; exclusions: PatientExclusions } {
  const gendered = filterQuestionnaireByGender(template, patient.sex ?? undefined);
  if (!frameV2On) return { questionnaire: gendered, exclusions: NO_EXCLUSIONS };
  const scoped = scopeToPatient(gendered, fhir, toLaunchPatient(patient.sex, patient.birthDateIso), today);
  return { ...scoped, questionnaire: normalizePopulationItems(scoped.questionnaire) };
}
